import PrivateFlowGate from "modules/projects/elements/Private-Flow-Wrapper";
import NewProjectLayout from "modules/projects/elements/New-Project-Entitlement-Wrapper";

import * as flowConfig from "flows/clustering/config";
import CreateNewProject from "flows/clustering/views/create-project";

const CreateProject = () => {
  return <CreateNewProject />;
};

CreateProject.getLayout = (page) => (
  <PrivateFlowGate flowName={flowConfig.FLOW_NAME}>
    <NewProjectLayout>{page}</NewProjectLayout>
  </PrivateFlowGate>
);

export default CreateProject;
